import { SIZE } from "./constants.js";

/**
 * Get size of Bytes32 (always 32)
 *
 * @see https://voltaire.tevm.sh/primitives/bytes/bytes32 for documentation
 * @since 0.0.0
 * @param {import('./Bytes32Type.js').Bytes32Type} _bytes - Bytes32 value
 * @returns {32} Size in bytes
 * @example
 * ```javascript
 * import * as Bytes32 from './primitives/Bytes/Bytes32/index.js';
 * const s = Bytes32.size(bytes); // 32
 * ```
 */
export function size(_bytes) {
	return SIZE;
}
